import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  CardActionArea,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemLink,
  Grid,
  CardHeader,
  Chip,
  CardMedia,
  IconButton,
  Avatar, 
  Divider
} from '@material-ui/core';

import { LocationOn, Assignment, Group, FormatListNumbered } from '@material-ui/icons';
import ImageGallery from 'react-image-gallery';
import "./image-gallery.scss";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 20
  },
  chip: {
    paddingBottom: 10,
    paddingTop: -10
  },
  green: {
    backgroundColor: 'primary',
    color: 'primary',
    justifyContent: 'flex-end'
  },
  image: {
    height: 48,
    width: 48
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const PicturesDisplay = props => {
  const { className, offer, ...rest } = props;

  const classes = useStyles();

  let offerPictureItems = [];
  offer.pictures.map((picture)=>{
    offerPictureItems.push({
      original: picture,
      thumbnail: picture,
    })
  });

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >

        {
          (offerPictureItems.length !== 0)?
            <CardContent className={classes.content}>
               <ImageGallery items={offerPictureItems}/>
            </CardContent>
          :
            <CardContent className={classes.content} style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",alignItems: 'center',
              justifyContent: 'center',}}>
                <Typography gutterBottom variant="h5" component="h2" style={{color: 'grey'}}>
                  No Picture to Display
                </Typography>
            </CardContent>
        }

 
    </Card>
  );
};

PicturesDisplay.propTypes = {
  className: PropTypes.string,
  offer: PropTypes.object.isRequired
};

export default PicturesDisplay;
